// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wELtD{width:208px;box-sizing:border-box;padding:12px}.f0rwk{width:100%;min-width:0}.rpW4y{width:100%}.cJmf6{display:grid !important;grid-template-columns:repeat(6, 24px);grid-auto-rows:24px;gap:8px;width:fit-content}.lXUpy{width:100%}.nPYZf{flex:1;min-width:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popupCard": `wELtD`,
	"segmentControlWrapper": `f0rwk`,
	"tabContent": `rpW4y`,
	"gradientGrid": `cJmf6`,
	"colorPickerFullWidth": `lXUpy`,
	"primaryBgColorPickerInputWrapper": `nPYZf`
};
export default ___CSS_LOADER_EXPORT___;
